import axios from "axios"
const apiBaseUrl = process.env.REACT_APP_APIBASE_URL

export const uploadNdaAgreementApi = async payload => {
    try {
      let apiToken = JSON.parse(localStorage.getItem("authUser"))
  
      const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "multipart/form-data",
        Authorization: apiToken,
        Accept: "application/json",
        "Cache-Control": "no-cache",
      }
      const response = await axios.post(`${apiBaseUrl}/uploadNDAagreement`, payload, {
        headers,
      })
      return response
    } catch (error) {
      console.error("Error adding lead:", error)
      throw error
    }
  }


  export const getNdaAgreementApi = async () => {
    try {
      let apiToken = JSON.parse(localStorage.getItem("authUser"))
  
      const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: apiToken,
        Accept: "application/json",
        "Cache-Control": "no-cache",
      }
      const response = await axios.get(`${apiBaseUrl}/get-NDAagreement`, {
        headers,
      })
      return response
    } catch (error) {
      console.error("Error adding lead:", error)
      throw error
    }
  }

  export const SendAgreementMailApi = async () => {
    try {
      let apiToken = JSON.parse(localStorage.getItem("authUser"))
  
      const headers = {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: apiToken,
        Accept: "application/json",
        "Cache-Control": "no-cache",
      }
      const response = await axios.post(`${apiBaseUrl}/send-NDAagreementMail`,{}, {
        headers,
      })
      return response
    } catch (error) {
      console.error("Error adding lead:", error)
      throw error
    }
  }